import { template as template_36238664cfa64aecb77d9888a54d11ae } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
export interface CodeBlockPatchFooterSignature {
    Args: {
    };
    Element: HTMLElement;
    Blocks: {
        default: [];
    };
}
const CodeBlockPatchFooterComponent: TemplateOnlyComponent<CodeBlockPatchFooterSignature> = template_36238664cfa64aecb77d9888a54d11ae(`
    <style scoped>
      footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--boxel-sp-xs);
        background-color: var(--boxel-650);
        color: var(--boxel-light);
        padding: 8px 12px;
        height: 60px;
      }

      :deep(.code-patch-error) {
        padding: 0;
      }
    </style>
    <footer>{{yield}}</footer>
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CodeBlockPatchFooterComponent;
